declare global {
    interface Date {
        toUtcDate(): Date
    }
}

Date.prototype.toUtcDate = function(): Date {
    return new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()))
}

export {};